import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="border-t border-gold-500/15 bg-primary-950 text-stone-200">
    <div className="container-responsive grid gap-10 py-14 md:grid-cols-4">
      <div className="md:col-span-2 space-y-4">
        <div className="flex items-center gap-3">
          <img src="/logo.png" alt="أرشيف الشهداء" className="h-12 w-12 rounded-xl" />
          <div>
            <p className="text-xs tracking-[0.3em] text-gold-400">متحف رقمي</p>
            <h2 className="text-2xl font-bold text-white">أرشيف الشهداء</h2>
          </div>
        </div>
        <p className="max-w-md leading-relaxed text-stone-400">
          منصة لتوثيق سيرة الشهداء بكرامة: السيرة، ما كُتب عنهم، القصائد، الصور والفيديو، ليبقى أثرهم حياً للأجيال.
        </p>
      </div>
      <div>
        <h3 className="mb-4 text-sm font-semibold text-gold-300">الأرشيف</h3>
        <ul className="space-y-2 text-stone-400">
          <li><Link className="hover:text-white" to="/martyrs">الشهداء</Link></li>
          <li><Link className="hover:text-white" to="/biography">السيرة الذاتية</Link></li>
          <li><Link className="hover:text-white" to="/timeline">الخط الزمني</Link></li>
          <li><Link className="hover:text-white" to="/writings">كتب عنه</Link></li>
          <li><Link className="hover:text-white" to="/poems">القصائد</Link></li>
        </ul>
      </div>
      <div>
        <h3 className="mb-4 text-sm font-semibold text-gold-300">المزيد</h3>
        <ul className="space-y-2 text-stone-400">
          <li><Link className="hover:text-white" to="/gallery">المعرض</Link></li>
          <li><Link className="hover:text-white" to="/gallery/photos">الصور</Link></li>
          <li><Link className="hover:text-white" to="/gallery/videos">الفيديوهات</Link></li>
          <li><Link className="hover:text-white" to="/guestbook">سجل الزوار</Link></li>
          <li><Link className="hover:text-white" to="/contact">تواصل</Link></li>
          <li><Link className="hover:text-white" to="/map">الخريطة</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-sm text-stone-500">
      حفظ الذكرى أمانة — أرشيف الشهداء
    </div>
  </footer>
);

export default Footer;
